import React from 'react';
import { oneOfType, arrayOf, node, string } from 'prop-types';

import { SCMenuHeader } from './styles';

MenuSection.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  label: string,
};

MenuSection.defaultProps = {
  label: null,
};

function MenuSection({ label, children }) {
  return (
    <div>
      {label && <SCMenuHeader>{label}</SCMenuHeader>}
      {children}
    </div>
  );
}

export default MenuSection;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuSection.js